import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import BrandMarquee from "@/components/site/BrandMarquee";
import Stats from "@/components/site/Stats";
import Services from "@/components/site/Services";
import TechStack from "@/components/site/TechStack";
import Approach from "@/components/site/Approach";
import EfficiencyCalculator from "@/components/site/EfficiencyCalculator";
import Portfolio from "@/components/site/Portfolio";
import Contact from "@/components/site/Contact";
import Privacy from "@/components/site/Privacy";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <BrandMarquee />
        <Stats />
        <Services />
        <TechStack />
        <Approach />
        <EfficiencyCalculator />
        <Portfolio />
        <Contact />
      </main>
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
          <div className="noise-overlay" aria-hidden />
          <ScrollToTop />
          <div className="relative min-h-screen bg-bg text-ink antialiased">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </div>
          <Toaster
            position="bottom-right"
            theme="light"
            toastOptions={{
              style: {
                background: "#FCFBF5",
                border: "1px solid #E4E2D5",
                color: "#1B1C12",
              },
            }}
          />
        </ReactLenis>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
